import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {SvgIcon} from '../../utils/svg-icon';
import {TipDialogData} from '../tip/tip-dialog/tip-dialog';
import {MessageBarStateEnum} from "./valg-message-bar.model";

let NEXT_ID = 0;
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'div[valg-message-bar]',
  templateUrl: './valg-message-bar.component.html',
  styleUrls: [ './valg-message-bar.component.scss' ],
  encapsulation: ViewEncapsulation.None,
})
export class ValgMessageBarComponent {
  @Input() color:
    | 'error'
    | 'error-gray'
    | 'approved'
    | 'approved-gray'
    | 'info-primary'
    | 'info-secondary'
    | 'info-gray'
    | 'info-white'
    | undefined;
  @Output() guidanceIconClickEvent = new EventEmitter<Event>();
  @Input() messageBarState: MessageBarStateEnum = MessageBarStateEnum.None;
  MessageBarStateEnum = MessageBarStateEnum;
  @Input() isSmall = false;
  @Input() showGuidance = false;
  @Input() tip: TipDialogData | undefined;
  @Input() useErrorIcon: boolean = true;
  @Input() roundedTop: boolean = false;
  elementClass = 'valg-message-bar';
  SvgIcon = SvgIcon;
  index = NEXT_ID++;

  isFirstAlert(): boolean {
    return this.index === 0;
  }
  public onGuidanceIconClick(event: Event): void {
    this.guidanceIconClickEvent.emit(event);
  }

  public shouldShowGuidance(){
    return this.isError() && this.showGuidance
  }

  public isError() {
    return this.color === 'error' || this.color === 'error-gray';
  }

}
